import * as Yup from "yup";

export const gateSchema = Yup.object({
    name: Yup.string().required(" Enter Gate Name"),
    detail: Yup.string().required(" Enter Detail"),
    password: Yup.string().required(" Enter Password"),
    // path: Yup.string().required(" Enter Path"),
    latitude: Yup.string().required(" Enter Latitude"),
    longitude: Yup.string().required(" Enter Longitude"),
    status: Yup.string().required("Select Status"),
    user_phone: Yup.string().required(" Enter User Phone"),
    gate_image: Yup.mixed().nullable(),
});


export const updateGateSchema = Yup.object({
    name: Yup.string().required(" Enter Gate Name"),
    detail: Yup.string().required(" Enter Detail"),
    // password: Yup.string().required(" Enter Password"),
    // path: Yup.string().required(" Enter Path"),
    latitude: Yup.string().required(" Enter Latitude"),
    longitude: Yup.string().required(" Enter Longitude"),
    status: Yup.string().required("Select Status"),
    user_phone: Yup.string().required(" Enter User Phone"),
    gate_image: Yup.mixed().nullable(),
});
